import { render, staticRenderFns } from "./ProductPreviewComponent.vue?vue&type=template&id=3f6fa68b&scoped=true&"
import script from "./ProductPreviewComponent.vue?vue&type=script&lang=js&"
export * from "./ProductPreviewComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductPreviewComponent.vue?vue&type=style&index=0&id=3f6fa68b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6fa68b",
  null
  
)

export default component.exports